import React from 'react';

export const ErrorSpan = ({ children }: { children: string | undefined }) => (
  <p className="text-red-500 text-sm font-body font-normal mb-[22px] ml-[6px] flex items-center">
    {children}
  </p>
);
